function inlineOptionsFrom(rules) {
  if (Array.isArray(rules)) {
    return rules;
  }

  if (rules === false) {
    return ['none'];
  }

  return undefined === rules ?
    ['local'] :
    rules.split(',');
}

module.exports = inlineOptionsFrom;



//////////////////
// WEBPACK FOOTER
// ./~/clean-css/lib/options/inline.js
// module id = 2312
// module chunks = 0